import { z } from "zod";

export const searchPrefetchSourceSchema = z.enum([
    "find_feed_row",
    "find_breed_chip",
    "filter_draft",
]);

export const searchPrefetchObservationSchema = z.enum([
    "attempted",
    "network_initiated",
    "network_completed",
    "dedup_reuse",
    "ready_hit",
    "stale_data_reused",
    "inflight_joined",
    "displayed",
    "expired_unused",
    "cancelled",
    "error",
]);

export const searchPrefetchAttemptSchema = z.object({
    attemptId: z.uuid(),
    searchKeyId: z.uuid(),
    source: searchPrefetchSourceSchema,
    observations: z.array(searchPrefetchObservationSchema).min(1).max(11),
    networkDurationMs: z.number().int().nonnegative().max(600_000).optional(),
    networkDurationCensored: z.boolean().optional(),
    readyAgeMs: z.number().int().nonnegative().max(300_000).optional(),
    prefetchedResultCount: z.number().int().nonnegative().max(5_000).optional(),
    displayedResultCount: z.number().int().nonnegative().max(5_000).optional(),
    hydratedResultCount: z.number().int().nonnegative().max(5_000).optional(),
});

export type SearchPrefetchSource = z.infer<typeof searchPrefetchSourceSchema>;
export type SearchPrefetchObservation = z.infer<
    typeof searchPrefetchObservationSchema
>;
export type SearchPrefetchAttempt = z.infer<typeof searchPrefetchAttemptSchema>;
